<script lang="ts">
  import Tab from "../../../components/Tab/Tab.svelte";
  import Tabs from "../../../components/Tab/Tabs.svelte";
  import QualityLayout from "../../../layout/QualityLayout.svelte";
  import QualityDocumentManager from "../../QualityDocument/QualityDocumentManager.svelte";

  enum QualityH2OPage {
    Analisi = 1,
    Trattamento,
  }

  let currentTab: QualityH2OPage = QualityH2OPage.Analisi;
</script>

<QualityLayout>
  <div class="quality-analysis-main-controls">
    <div class="analysis-tabs">
      <Tabs>
        <Tab
          label="Analisi"
          active={currentTab == QualityH2OPage.Analisi}
          on:click={(_) => {
            currentTab = QualityH2OPage.Analisi;
          }}
        />
        <Tab
          label="Trattamento"
          active={currentTab == QualityH2OPage.Trattamento}
          on:click={(_) => {
            currentTab = QualityH2OPage.Trattamento;
          }}
        />
      </Tabs>
    </div>
  </div>

  {#if currentTab == QualityH2OPage.Analisi}
    <QualityDocumentManager entityName="analisi" clfDocTypeCode="H2OANALISI" withVersion={false} comparisonUrl="/limiti/LIMITI_ACQUA.pdf" />
  {/if}
  {#if currentTab == QualityH2OPage.Trattamento}
    <QualityDocumentManager entityName="trattamento" clfDocTypeCode="H2OTRATTAM" withVersion={false} />
  {/if}
</QualityLayout>

<style>
  .quality-analysis-main-controls {
    display: flex;
    flex-direction: row;
    margin-bottom: 1rem;
  }
  .quality-analysis-main-controls .analysis-tabs {
    flex: 1;
  }
</style>
